/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RansomwareRecoveryErrorCode = 'FAILED_CREATING_PROVISIONING_REQUEST' | 'FAILED_CREATING_PROVISIONING_RESPONSE' | 'DEPLOYMENT_IN_INVALID_STATE_FOR_POP_ID' | 'FAILED_UPDATE_REF_COUNT_FOR_POP_ID' | 'FAILED_CLM_PROVISION_API_CALL_FOR_POP_ID' | 'FAILED_IN_FINDING_AWS_REGION_POP_ID_MAPPING' | 'DEPLOYMENT_IN_PROGRESS_FOR_AWS_REGION' | 'DEPLOYMENT_IN_DEACTIVATION_PENDING_APPROVAL_FOR_AWS_REGION' | 'DEPLOYMENT_IN_INVALID_STATE_FOR_AWS_REGION' | 'FAILED_IN_GETTING_SUCCESS_STATUS' | 'FAILED_IN_GETTING_LOCK_OBJECT' | 'INVALID_DEPLOYMENT_FOR_DEACTIVATION' | 'DEACTIVATION_WITHOUT_APPROVAL' | 'FAILED_IN_GETTING_ORG_KEY_FOR_CB_POP_DEPROVISION' | 'FAILED_CREATING_DEPROVISIONING_REQUEST' | 'FAILED_CREATING_DEPROVISIONING_RESPONSE' | 'FAILED_CB_POP_DEPROVISIONING' | 'DEPLOYMENT_IN_DELETING_FOR_AWS_REGION' | 'FORBIDDEN_COUNTRY_ERROR_IN_PROVISIONING_RESPONSE' | 'DEPLOYMENT_IN_INVALID_STATE_FOR_CHILD_ORG_ID';

export const RansomwareRecoveryErrorCode = {

    FAILED_CREATING_PROVISIONING_REQUEST: 'FAILED_CREATING_PROVISIONING_REQUEST' as RansomwareRecoveryErrorCode,

    FAILED_CREATING_PROVISIONING_RESPONSE: 'FAILED_CREATING_PROVISIONING_RESPONSE' as RansomwareRecoveryErrorCode,

    DEPLOYMENT_IN_INVALID_STATE_FOR_POP_ID: 'DEPLOYMENT_IN_INVALID_STATE_FOR_POP_ID' as RansomwareRecoveryErrorCode,

    FAILED_UPDATE_REF_COUNT_FOR_POP_ID: 'FAILED_UPDATE_REF_COUNT_FOR_POP_ID' as RansomwareRecoveryErrorCode,

    FAILED_CLM_PROVISION_API_CALL_FOR_POP_ID: 'FAILED_CLM_PROVISION_API_CALL_FOR_POP_ID' as RansomwareRecoveryErrorCode,

    FAILED_IN_FINDING_AWS_REGION_POP_ID_MAPPING: 'FAILED_IN_FINDING_AWS_REGION_POP_ID_MAPPING' as RansomwareRecoveryErrorCode,

    DEPLOYMENT_IN_PROGRESS_FOR_AWS_REGION: 'DEPLOYMENT_IN_PROGRESS_FOR_AWS_REGION' as RansomwareRecoveryErrorCode,

    DEPLOYMENT_IN_DEACTIVATION_PENDING_APPROVAL_FOR_AWS_REGION: 'DEPLOYMENT_IN_DEACTIVATION_PENDING_APPROVAL_FOR_AWS_REGION' as RansomwareRecoveryErrorCode,

    DEPLOYMENT_IN_INVALID_STATE_FOR_AWS_REGION: 'DEPLOYMENT_IN_INVALID_STATE_FOR_AWS_REGION' as RansomwareRecoveryErrorCode,

    FAILED_IN_GETTING_SUCCESS_STATUS: 'FAILED_IN_GETTING_SUCCESS_STATUS' as RansomwareRecoveryErrorCode,

    FAILED_IN_GETTING_LOCK_OBJECT: 'FAILED_IN_GETTING_LOCK_OBJECT' as RansomwareRecoveryErrorCode,

    INVALID_DEPLOYMENT_FOR_DEACTIVATION: 'INVALID_DEPLOYMENT_FOR_DEACTIVATION' as RansomwareRecoveryErrorCode,

    DEACTIVATION_WITHOUT_APPROVAL: 'DEACTIVATION_WITHOUT_APPROVAL' as RansomwareRecoveryErrorCode,

    FAILED_IN_GETTING_ORG_KEY_FOR_CB_POP_DEPROVISION: 'FAILED_IN_GETTING_ORG_KEY_FOR_CB_POP_DEPROVISION' as RansomwareRecoveryErrorCode,

    FAILED_CREATING_DEPROVISIONING_REQUEST: 'FAILED_CREATING_DEPROVISIONING_REQUEST' as RansomwareRecoveryErrorCode,

    FAILED_CREATING_DEPROVISIONING_RESPONSE: 'FAILED_CREATING_DEPROVISIONING_RESPONSE' as RansomwareRecoveryErrorCode,

    FAILED_CB_POP_DEPROVISIONING: 'FAILED_CB_POP_DEPROVISIONING' as RansomwareRecoveryErrorCode,

    DEPLOYMENT_IN_DELETING_FOR_AWS_REGION: 'DEPLOYMENT_IN_DELETING_FOR_AWS_REGION' as RansomwareRecoveryErrorCode,

    FORBIDDEN_COUNTRY_ERROR_IN_PROVISIONING_RESPONSE: 'FORBIDDEN_COUNTRY_ERROR_IN_PROVISIONING_RESPONSE' as RansomwareRecoveryErrorCode,

    DEPLOYMENT_IN_INVALID_STATE_FOR_CHILD_ORG_ID: 'DEPLOYMENT_IN_INVALID_STATE_FOR_CHILD_ORG_ID' as RansomwareRecoveryErrorCode
};

